// La Clica food-vendor secondary: elotero steaming pot.
// Silhouette = tall metal pot with corn cob silhouettes + steam rising +
// garnish lineup along the front (mayo/crema/chile dust + lime tray).

interface EloteroPotProps {
  /** Pot / steam color (chrome / off-white). */
  bodyColor?: string;
  /** Garnish accent (chile dust red). */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function EloteroPot({
  bodyColor = '#c0c4ca',
  accentColor = '#e6342a',
  size = 48,
  className,
}: EloteroPotProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Steam — 3 wisps rising */}
      <path
        d="M18 4 Q16 8 18 12 Q20 8 18 4"
        fill="rgba(255,255,255,0.5)"
      />
      <path
        d="M24 2 Q22 6 24 10 Q26 6 24 2"
        fill="rgba(255,255,255,0.6)"
      />
      <path
        d="M30 4 Q28 8 30 12 Q32 8 30 4"
        fill="rgba(255,255,255,0.5)"
      />
      {/* Pot rim — wider than body */}
      <ellipse cx="24" cy="16" rx="14" ry="3" fill={bodyColor} />
      {/* Pot body — slightly tapered */}
      <path
        d="M11 16 L13 36 L35 36 L37 16 Z"
        fill={bodyColor}
      />
      {/* Pot highlight — left edge */}
      <rect x="11" y="16" width="2" height="20" fill="rgba(255,255,255,0.3)" />
      {/* Pot shadow — right edge */}
      <rect x="35" y="16" width="2" height="20" fill="rgba(0,0,0,0.25)" />
      {/* Corn cob — visible above rim (one peeking out) */}
      <ellipse cx="22" cy="15" rx="3" ry="4" fill="#d4a945" />
      {/* Corn kernels — dots */}
      {[[21,13],[23,13],[20,15],[22,15],[24,15],[21,17],[23,17]].map(([x,y],i)=>(
        <circle key={i} cx={x} cy={y} r="0.6" fill="#a8821e" />
      ))}
      {/* Pot handles — small loops on sides */}
      <path d="M9 24 Q6 26 9 30" stroke={bodyColor} strokeWidth="1.5" fill="none" />
      <path d="M39 24 Q42 26 39 30" stroke={bodyColor} strokeWidth="1.5" fill="none" />
      {/* Garnish row — bottom front (mayo bottle, chile shaker, lime) */}
      <rect x="14" y="38" width="3" height="8" rx="0.5" fill="#f5ecd6" />
      <rect x="19" y="38" width="3" height="8" rx="0.5" fill={accentColor} />
      <rect x="24" y="38" width="3" height="8" rx="0.5" fill="#f5ecd6" />
      <circle cx="31" cy="42" r="3" fill="#5fd17e" />
    </svg>
  );
}
